module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation/survey_flow_pollandroll-0c4ed071e5e54d83188a247b4372c1ff.png";